import { createSlice } from "@reduxjs/toolkit";

export const FLOW_TYPE_PERSONAL_CYBER_STANDARD = "FLOW_TYPE_PERSONAL_CYBER_STANDARD";

const initialState = {
    flowType: FLOW_TYPE_PERSONAL_CYBER_STANDARD,
    currentStepIndex: 0,
    currentSubstepIndex: 0,
};

const personalCyberFlowSlice = createSlice({
    name: "personalCyberFlow",
    initialState,
    reducers: {
        setFlowType: (state, action) => {
            const data = action.payload;
            state.flowType = data.type;
            state.currentStepIndex = data.currentStepIndex || 0;
            state.currentSubstepIndex = data.currentSubstepIndex || 0;
        },
        setCurrentStepIndex: (state, action) => {
            state.currentStepIndex = action.payload;
            state.currentSubstepIndex = 0;
        },
        setCurrentSubstepIndex: (state, action) => {
            state.currentSubstepIndex = action.payload;
        },
        clearPersonalCyberFlow: () => initialState
    }
});

export const selectPersonalCyberFlow = (store) => store.personalCyberFlow;
export const selectPersonalCyberFlowType = (store) => store?.personalCyberFlow?.flowType;
export const selectPersonalCyberCurrentStepIndex = (store) => store?.personalCyberFlow?.currentStepIndex;
export const selectPersonalCyberCurrentSubstepIndex = (store) => store.personalCyberFlow?.currentSubstepIndex;

export const { 
    setFlowType, 
    setCurrentStepIndex, 
    setCurrentSubstepIndex, 
    clearPersonalCyberFlow 
} = personalCyberFlowSlice.actions;

export default personalCyberFlowSlice.reducer;